import Vue from 'vue'
import axios from 'axios'

export function repayActiveRepay(parms = {}) {
  return axios({
    url: '/saas/repay/activeRepay',
    method: 'post',
    data: parms
  })
}
Vue.prototype.$api = {

}